module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.inHomeView ? true : _vm.showNewsletter) ? _c('div', {
    staticClass: "monster-newsletter-widget gtm-onElementVisiblity",
    class: ("theme-" + (_vm.newsletterType.color)),
    attrs: {
      "gtm-on": "elementVisibility",
      "gtm-visibility-category": _vm.gtmNewsletterCategory,
      "gtm-visibility-action": "Newsletter widget impression",
      "gtm-visibility-label": _vm.newsletterType.name
    }
  }, [_c('div', {
    staticClass: "content-row"
  }, [_c('div', {
    staticClass: "envelopes-wrapper left"
  }, _vm._l((5), function(x) {
    return _c('div', {
      key: x,
      staticClass: "envelope-row animated",
      class: {
        odd: x % 2 === 1, even: x % 2 === 0
      }
    }, _vm._l((7), function(y) {
      return _c('svg-email-eight-bit-icon', {
        key: y,
        staticClass: "email-icon",
        class: {
          first: y === 1, last: y === 7
        },
        attrs: {
          "fill": "#F8008E",
          "width": "30",
          "height": "21"
        }
      })
    }))
  })), _c('div', {
    ref: "rectWrappersContainer",
    staticClass: "rect-wrappers-container animated"
  }, [_c('div', {
    staticClass: "monster-wrappers"
  }, [_c('div', {
    staticClass: "monster-content"
  }, [_c('div', {
    staticClass: "monster-icon"
  }, [_c('svg-email-monster-icon', {
    attrs: {
      "width": "394",
      "height": "138"
    }
  })], 1), _c('div', {
    staticClass: "monster-email-row"
  }, _vm._l((3), function(n) {
    return _c('svg-email-eight-bit-icon', {
      key: n,
      class: {
        first: n === 1, last: n === 3
      },
      attrs: {
        "width": "39",
        "height": "28"
      }
    })
  }))]), _c('div', {
    staticClass: "message-headline",
    class: _vm.newsletterType.color
  }, [_vm._v("thank you")]), _c('div', {
    staticClass: "message-content",
    class: _vm.newsletterType.color
  }, [_vm._v("you are now on the email list")])]), _c('div', {
    staticClass: "rect-wrapper-parent"
  }, [_c('div', {
    staticClass: "rect-wrapper-content"
  }, [_c('div', {
    staticClass: "brand-title"
  }, [_vm._v("GET OUR")]), _c('div', {
    staticClass: "newsletter-type",
    class: _vm.newsletterType.color
  }, [_vm._v(_vm._s(_vm.newsletterType.name))]), _c('div', {
    staticClass: "newsletter-title",
    class: _vm.newsletterType.color
  }, [_vm._v("NEWSLETTER")])]), _vm._l((5), function(n) {
    return _c('div', {
      staticClass: "rect-wrapper first",
      class: [_vm.newsletterType.color, 'rect-wrapper-frame-' + n]
    }, [_c('div', {
      staticClass: "rect-wrapper second",
      class: _vm.newsletterType.color
    }, [_c('div', {
      staticClass: "rect-wrapper third",
      class: _vm.newsletterType.color
    }, [_c('div', {
      staticClass: "rect-wrapper forth",
      class: _vm.newsletterType.color
    }, [_c('div', {
      staticClass: "rect-wrapper fifth",
      class: _vm.newsletterType.color
    })])])])])
  })], 2), (!_vm.submit) ? _c('div', {
    staticClass: "newsletter-form"
  }, [_c('form', {
    staticClass: "mx-auto disable-translate3d",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-center disable-translate3d"
  }, [_c('div', {
    staticClass: "form-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.monsterEmail),
      expression: "monsterEmail",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "w-100 form-control border-0 pl-2 pr-2 input-email",
    class: {
      'warning-color': _vm.warning
    },
    attrs: {
      "type": "email",
      "placeholder": "your email"
    },
    domProps: {
      "value": (_vm.monsterEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.monsterEmail = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('button', {
    staticClass: "form-btn btn submit-newsletter",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("SIGN UP")])]), _c('div', {
    staticClass: "warning notification",
    class: {
      'warning-color': _vm.warning
    }
  }, [(_vm.warning) ? _c('div', {
    staticClass: "d-flex align-items-center pr-3 pl-3 h-100"
  }, [_vm._v("Email Address is not valid.")]) : _vm._e()])])]) : _vm._e()]), _c('div', {
    staticClass: "envelopes-wrapper right"
  }, _vm._l((5), function(x) {
    return _c('div', {
      key: x,
      staticClass: "envelope-row animated",
      class: {
        odd: x % 2 === 1, even: x % 2 === 0
      }
    }, _vm._l((7), function(y) {
      return _c('svg-email-eight-bit-icon', {
        key: y,
        staticClass: "email-icon",
        class: {
          first: y === 1, last: y === 7
        },
        attrs: {
          "fill": "#F8008E",
          "width": "30",
          "height": "21"
        }
      })
    }))
  }))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50a5fd5c","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/widgets/MonsterNewsletterFormDesktop.vue
// module id = 1175
// module chunks = 1 31